import React from 'react';

const Card = ({ image, title, description, className = '', imageClassName = '', contentClassName = '' }) => {
  return (
    <div className={`group relative overflow-hidden rounded-lg ${className}`}>
      <div className="relative h-80 w-full overflow-hidden">
        <img
          src={image}
          alt={title}
          className={`h-full w-full object-cover transition-transform duration-300 group-hover:scale-105 ${imageClassName}`}
        />
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      </div>
      <div className={`absolute bottom-0 left-0 right-0 p-6 text-white ${contentClassName}`}>
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        {description && (
          <p className="text-sm text-gray-200 opacity-0 transform translate-y-4 transition-all duration-300 group-hover:opacity-100 group-hover:translate-y-0">
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

export default Card;
